import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Form, InputGroup, Col, Row, } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';
import DBService from '../../service/DBService';
import ScreenerSelect from './ScreenerSelect';
import ATSShowDetails from './ATSShowDetails';
import '../../css/ATSListDisplay.css';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };
    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                <Form.Control size="sm" type="text" placeholder="Search" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "issueSymbolIdentifier",
        text: "Ticker",
        sort: 'True',
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "totalWeeklyShareQuantity",
        text: "Total Shares",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }
    },
    {
        dataField: "totalWeeklyTradeCount",
        text: "Total Trades",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    },
    {
        dataField: "",
        text: "Details",
        sort: false,
        formatter: (cell, row) => <i className={'fa fa-file-text'} style={{ height: '10px', width: '10px', cursor: 'pointer' }}></i>,
        headerStyle: { fontSize: '10px', width: '50px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'center'
            }
        },
    },
];


const columns = [
    {
        dataField: "issueSymbolIdentifier",
        text: "Ticker",
        sort: 'True',
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "issueName",
        text: "Description",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "totalWeeklyShareQuantity",
        text: "Total Shares",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }
    },
    {
        dataField: "totalWeeklyTradeCount",
        text: "Total Trades",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    },
    {
        dataField: "lastUpdateDate",
        text: "Last Updated",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false
    },
    {
        dataField: "",
        text: "Details",
        sort: false,
        formatter: (cell, row) => <i className={'fa fa-file-text'} style={{ height: '10px', width: '10px', cursor: 'pointer' }}></i>,
        headerStyle: { fontSize: '10px', width: '80px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'center',
            }
        },
    },

];

const expandRow = {
    onlyOneExpanding: true,
    parentClassName: 'my-parent-expand-foo',
    showExpandColumn: true,
    renderer: row => (
        <ATSShowDetails week={row.lastUpdateDate} symbol={row.issueSymbolIdentifier} />
    )
};

const rowStyle = (row, rowIndex) => {
    const style = {};
    style.fontSize = '10px';
    style.textAlign = 'right';
    return style;
};

class ATSListDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symbol: this.props.symbol,
            atsWeeklyList: [],
            reload: false,
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: '',
            weeklyOptions: [],
        };
        console.log('ATSListDisplay props', this.props, this.state.symbol);
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        DBService.getAtsDistinctWeeks()
            .then(result => {
                console.log('ats getAtsDistinctWeeks', result);
                if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                    result = result.data;
                    let tmpOptions = [];
                    for (var i = 0; i < result.length; i++) {
                        if (i === 0) {
                            tmpOptions.push({ "labelKey": { criteria: 'weekly', value: result[i].lastUpdateDate }, "value": result[i].lastUpdateDate, "isSelected": true });
                        } else {
                            tmpOptions.push({ "labelKey": { criteria: 'weekly', value: result[i].lastUpdateDate }, "value": result[i].lastUpdateDate });
                        }
                    }
                    console.log('ats weeklyOptions', tmpOptions, tmpOptions[0].value);
                    DBService.getAtsWeeklyTotal(tmpOptions[0].value)
                        .then(result => {
                            console.log('ats getAtsWeeklyTotal', result);
                            if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                                result = result.data;
                                this.setState({ weeklyOptions: tmpOptions, atsWeeklyList: result, reload: true });
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    selectUpdateObj(selectedOptions) {
        let tmpObj = {
            selectedKey: [
                JSON.parse(selectedOptions.target.value)
            ],
            selectedValue: []
        }
        return tmpObj;
    }

    handleWeeklyChange = (selectedOptions) => {
        this.selectedWeekly = this.selectUpdateObj(selectedOptions);
        console.log('ats Screen Criteria -selected weekly', this.selectedWeekly, selectedOptions);
        const key = this.selectedWeekly.selectedKey[0];
        DBService.getAtsWeeklyTotal(key.value)
            .then(result => {
                console.log('ats getAtsWeeklyTotal', result);
                if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                    result = result.data;
                    this.setState({ atsWeeklyList: result });
                }
            })
            .catch((error) => {
                console.log(error);
            });

    }

    render() {
        if (this.state.reload) {
            console.log('ATSListDisplay Reloading...');
            this.setState({ reload: false });
            return (<div>Loading...</div>);
        }

        return (
            <>
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="issueSymbolIdentifier"
                        data={this.state.atsWeeklyList}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>  <Row>
                                    <Col xs={4} sm={5} md={3} lg={2}>
                                        <ScreenerSelect options={this.state.weeklyOptions} onChange={this.handleWeeklyChange} label={'Weekly Report'} />
                                    </Col>
                                    <Col>
                                        <MySearch {...props.searchProps} />
                                    </Col>
                                </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        expandRow={expandRow}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="issueSymbolIdentifier"
                        data={this.state.atsWeeklyList}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <Row>
                                        <Col xs={5} sm={5} md={4} lg={2}>
                                            <ScreenerSelect options={this.state.weeklyOptions} onChange={this.handleWeeklyChange} label={'Weekly Report'} />
                                        </Col>
                                        <Col>
                                            <MySearch {...props.searchProps} />
                                        </Col>
                                    </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        expandRow={expandRow}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
            </>
        );
    }
}

export default ATSListDisplay;
